import type { IModuleRoute } from 'zova-module-a-router';

import { ZPageHome } from './.metadata/page/home.js';

export const routes: IModuleRoute[] = [
  //
  { path: '', component: ZPageHome },
];
